import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const CallToActions = () => {
  return (
    <div className="flex pt-3 mt-2 flex-col lg:flex-row gap-3 lg:gap-5">
      <a
        href="tel:01865965122"
        className="bg-indigo-500 hover:bg-indigo-700 text-white font-medium py-2 px-6 rounded-lg transition-colors"
      >
        Call us
      </a>
      <a
        href="mailto:info@leda-group.co.uk"
        className="bg-white text-black font-medium py-2 px-6 rounded-lg border border-gray-300"
      >
        Message
      </a>
    </div>
  );
};
const ServiceBox = ({ img, title, desc }) => {
  return (
    <div className="p-10 border border-gray-200 rounded-lg bg-white">
      <img src={img} alt={title} className="mx-auto mb-4 w-3/5" />
      <h3 className="font-bold text-lg mb-2">{title}</h3>
      <p className="min-h-12">{desc}</p>
      <CallToActions />
    </div>
  );
};

const LedaHome = () => {
  return (
    <>
      <Header />
      {/* Services Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4 text-center">
          <ServiceBox
            img="/leda-group/trades_labour.png"
            title="Trades & Labour"
            desc="General labour, site welfare and skilled local trades"
          />

          <ServiceBox
            img="/leda-group/mechanical-electrical.png"
            title="Mechanical & Electrical"
            desc="Commercial, industrial and residential trade professionals"
          />

          <ServiceBox
            img="/leda-group/site-project-management.png"
            title="Site & Project Management"
            desc="Experienced project and site managers"
          />

          <ServiceBox
            img="/leda-group/nationwide-delivery.png"
            title="Nationwide Delivery"
            desc="Over 20,000 skilled professionals registered nationwide"
          />

          <ServiceBox
            img="/leda-group/speed-reliability.png"
            title="Speed & Reliability"
            desc="We understand the fast-paced nature of construction"
          />

          <ServiceBox
            img="/leda-group/security-clearance.png"
            title="Security Clearance"
            desc="Specialist security clearance handled for you"
          />
        </div>
      </section>
      <section className="pb-16 bg-gray-50 m-auto">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="flex justify-center">
              <img
                src="/leda-group/leda-cards.png"
                className="w-4/5 lg:w-3/4 max-w-md"
                alt="leda"
              />
            </div>
            <div className="flex flex-col text-center lg:text-left max-w-lg mx-auto lg:mx-0">
              <h3 className="text-3xl lg:text-4xl font-bold mb-4">
                With Leda, it's always personal
              </h3>
              <p className="text-lg">
                Whether you need reliable, high-quality professionals at short
                notice or a long-term workforce solution, your personal manager
                will be there to help.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default LedaHome;
